/* =============================================================
 * import
 * ========================================================== */
import {gsap} from 'gsap';
import {CustomEase} from "gsap/CustomEase";

CustomEase.create("fadeCurtain", ".25, .46, .45, .94");
CustomEase.create("fade", "0.5, 1, 0.89, 1");

/* =============================================================
 * function
 * ========================================================== */
/*
export default function exe() {
}
*/

let player; // eslint-disable-line @typescript-eslint/no-unused-vars

function initializeYouTubePlayer() { // eslint-disable-line @typescript-eslint/no-unused-vars
  const videoID = '3Cpr00yda00';
  player = new YT.Player('player', { // eslint-disable-line no-undef
    videoId: videoID,
    playerVars: {
      'autoplay': 1,
      'playsinline': 1,
      'mute': 1,
      'controls': 0,  // コントロール設定
      'disablekb': 1, // 動画字幕
      'iv_load_policy': 3, // 動画アノテーション表示
      'modestbranding': 1, // YouTubeロゴ表示
      'loop': 1,  // ループ再生
      'playlist': videoID,  // ループ動画の再生リスト（同じ動画IDでループ）
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerStateChange,
    },
  });
}


function onPlayerReady(event) {
  const mask = document.querySelector('.main_mv_figure_picture');
  event.target.mute();
  event.target.playVideo();
  gsap.to(mask, {
    autoAlpha: 0,
    ease: "fade",
    duration: 1,
    delay: .8,
  });
  gsap.to(mask, {
    scale: 1.1,
    ease: "fade",
    duration: 1.8,
  });
}

function onPlayerStateChange(event) {
  if (event.data === YT.PlayerState.ENDED) { // eslint-disable-line no-undef
    event.target.playVideo();
  }
}



export function loadYouTubeAPI() {

  // YouTube APIが既に読み込まれているかをチェック
  if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') { // eslint-disable-line no-undef
    // YouTube IFrame Player APIのスクリプトタグを作成
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";

    // 最初のスクリプトタグを見つけて、その前に新しいタグを挿入
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // APIのロード完了後に初期化関数を設定
    window.onYouTubeIframeAPIReady = initializeYouTubePlayer;
  } else  {
    // APIが既に読み込まれている場合は直接初期化関数を呼び出す
    initializeYouTubePlayer();
  }
}
